export default __webpack_public_path__ + "static/media/icecast.381ff466.svg";